import React from 'react';

import { DeviceMismatchFields, getDeviceMismatch } from '../../utils/deviceProfileMismatch';
import MismatchFlag from '../MismatchFlag';
import * as Style from './style.module.scss';

/** Grid track the list must reserve for this always-rendered trailing cell. */
export const MISMATCH_ALERT_TRACK = '3rem';

// Right-aligned alert shown in a member-list row when the name or DOB the member
// set on the device differs from the form-filled values. Renders nothing (an empty
// trailing cell) when the values match. Used by lists that have no existing alert
// icon of their own (discharged, check-ins).
const MemberMismatchAlert: React.FC<DeviceMismatchFields> = (fields) => {
    const { hasMismatch, content } = getDeviceMismatch(fields);

    if (!hasMismatch) {
        return <div className={Style.iconColumn} />;
    }

    return (
        <div className={Style.iconColumn}>
            <MismatchFlag content={content} placement="left" />
        </div>
    );
};

export default MemberMismatchAlert;
